/* eslint-disable max-len */
import TocPrivacyPolicyFooter from "components/toc-privacypolicy-footer/TocPrivacyPolicyFooter";
// @ts-ignore
import "./CookiesNotice.scss";

const CookiesNotice = () => {
  return (
    <div className="max-w-[1200px] m-auto">
      <div className="toc-privacy">
        <div className="title-container flex justify-between items-center gap-4 flex-wrap">
          <div>
            <h3>Cookie Policy</h3>
            <div className="last-updated">
              Last updated: July 28, 2024{" "}
              {/* <SvgIcon name="arrow_bottom" className="arrow-icon" /> */}
            </div>
          </div>
          <div className="">
            <button className="cky-banner-element h-[36px] bg-secondary text-white rounded-md flex items-center justify-center px-4">
              Consent Preferences
            </button>
            {/* <Button
              color={COLORS.SECONDARY}
              variant={VARIANTS.FILLED}
              className="!h-[36px] block cky-banner-element"
              text="Consent Preferences"
            /> */}
          </div>
        </div>
        <section className="contents">
          <article className="content">
            <p>
              This Cookie Policy details how Pointment Inc. (“Pointment,” “us,”
              “we,” or “our”) uses and categorizes cookies on the pointmentapp
              websites, as well as how to manage your consent regarding their
              use.
              <br />
              <br />
              This Cookie Policy should be read together with our{" "}
              <a
                href="/privacypolicy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Statement
              </a>
              , which describes how and why we collect, store, use, and protect
              personal data.
            </p>
            <br />
            <h5>Cookies</h5>
            <p>
              A cookie is a small text file that may be stored on your computer
              or mobile device when you visit one of our Sites or use one of our
              Products. In cases where cookies are used, the respective Site or
              Product will send certain data to your browser (e.g., when you
              first visit) and then store the data on your device, so that the
              Site or Product can access, store, or collect information from
              your device.
              <br />
              <br />
              Browsers support cookies so that websites can perform certain
              functions, including remembering information about your visit to
              improve your experience, creating aggregated and anonymized usage
              statistics, fraud prevention, and information security purposes.
              In this Cookie Policy, we use the term “cookie” to refer both to
              cookies and similar technologies (such as local storage and
              pixels).
              <br />
              <br />
              Cookies may be set by us (“first-party cookies”) or by a third
              party, such as those who provide us with analytics or facilitate
              advertising services or interactive content (“third-party
              cookies”). Our Sites may also provide links to third parties who
              may also use cookies in accordance with their own separate cookie
              and privacy notices/policies.
            </p>
            <br />
            <h5>Categories of Cookies</h5>
            <p>
              Pointment categorizes the use of cookies into four main
              categories: (1) strictly necessary; (2) performance; (3)
              functional; and (4) targeting. Pointment and third parties will
              only use cookies in categories you have consented to. However,
              please note that opting out of cookies may result in some
              functions not working properly.
              {/* <br />
              <br />
              You can review the cookies used by a particular Site by clicking
              the ‘Your Privacy Choices’ link at the bottom of the page. You can
              also withdraw your consent to the use of cookies (other than
              strictly necessary cookies) and manage your cookie preferences
              here. Please note that it may be necessary to reset your cookies
              and/or refresh the page for the updated settings to go into
              effect. */}
              <br />
              <br />A list of the categories of cookies used on our website
              domains is set out below:
            </p>
          </article>
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr>
                <th
                  className="border border-gray-300 px-4 py-2 text-left bg-gray-50"
                  scope="col"
                >
                  Category{" "}
                </th>
                <th
                  className="border border-gray-300 px-4 py-2 text-left bg-gray-50"
                  scope="col"
                >
                  Description{" "}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2 align-top">
                  Strictly Necessary{" "}
                </td>
                <td className="border border-gray-300 px-4 py-2 align-top">
                  These cookies are necessary for our website to function
                  properly and securely, and cannot be switched off in our
                  systems. They are usually only set in response to actions made
                  by you which amount to a request for services, such as setting
                  your privacy preferences, logging in, filling in forms, or
                  where they’re essential to provide you with a service you have
                  requested. You cannot opt-out of these cookies. You can set
                  your browser to block or alert you about these cookies, but if
                  you do, some parts of the site will not then work.{" "}
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 align-top">
                  Performance Cookies
                </td>
                <td className="border border-gray-300 px-4 py-2 align-top">
                  These cookies allow us to count visits and traffic sources so
                  we can measure and improve the performance of our site. They
                  help us to know which pages are the most and least popular and
                  see how visitors move around the site, which helps us optimize
                  your experience. All information these cookies collect is
                  aggregated and therefore anonymous. If you do not allow these
                  cookies, we will not be able to use your data in this way.
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 align-top">
                  Functional Cookies
                </td>
                <td className="border border-gray-300 px-4 py-2 align-top">
                  These cookies enable the website to provide enhanced
                  functionality and personalization. They may be set by us or by
                  third party providers whose services we have added to our
                  pages. If you do not allow these cookies, then some or all of
                  these services may not function properly.
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 align-top">
                  Targeting Cookies
                </td>
                <td className="border border-gray-300 px-4 py-2 align-top">
                  These cookies are used to make advertising messages more
                  relevant to you and may be set through our site by us or by
                  our advertising partners. They may be used to build a profile
                  of your interests and show you relevant advertising on our
                  site or on other sites. They do not store directly personal
                  information, but are based on uniquely identifying your
                  browser and internet device.
                </td>
              </tr>
            </tbody>
          </table>
          <article className="content">
            <h5>Our Use of Cookies</h5>
            <p>
              <b>General Browsing:</b> We use cookies that are important for
              certain technical features, like logging into user accounts and
              implementing fixes or improvements to our platform.
              <br />
              <br />
              These cookies:
              <br />
              <br />
              <ul className="list-disc ml-6">
                <li>
                  Enable behavior that is tailored to the activity or
                  preferences of a person visiting our Sites.
                </li>
                <li>
                  Allow users to opt-out of certain types of modeling,
                  tailoring, or personalization in our products.
                </li>
                <li>
                  Collect information on our users’ preferences in order to
                  create more useful Sites and Products.
                </li>
                <li>
                  Drive and tailor the advertising and marketing of our Sites
                  and Products.
                </li>
                <li>
                  Help to diagnose and correct downtime, bugs, and errors in our
                  code to ensure that our Sites are operating efficiently.
                </li>
              </ul>
              <br />
            </p>
            <p>
              <b>Advertising:</b> We use cookies to enable advertising with our
              third-party partners, which allows us to continue to provide our
              Sites free of charge.
              <br />
              <br />
              These cookies:
              <br />
              <br />
              <ul className="list-disc ml-6">
                <li>Customize the ad experience for users.</li>
                <li>
                  Help us measure ad performance (e.g., whether an ad was viewed
                  or clicked on) for internal reporting and product
                  optimization.
                </li>
              </ul>
              <br />
              <br />
            </p>
            <p>
              <b>Analytics:</b> We use cookies to compile usage activity to
              better tailor our Sites and Products. We DO NOT share personally
              identifiable “raw” data with anyone through the use of cookies; we
              make high-level decisions based on aggregated and anonymized data
              about overall usage of our Sites and Products.
              <br />
              <br />
              These cookies:
              <br />
              <br />
              <ul className="list-disc ml-6">
                <li>Monitor Site and/or Product traffic and trends.</li>
                <li>Measure the effectiveness of On-Prem Products.</li>
                <li>Measure the effectiveness of marketing campaigns.</li>
              </ul>
              <br />
            </p>
          </article>
          <article className="content">
            <h5>Changes to This Cookie Policy</h5>
            <p>
              We may update this Cookie Policy from time to time in order to
              reflect, for example, changes to the cookies we use or for other
              operational, legal, or regulatory reasons. Please therefore
              re-visit this Cookie Policy regularly to stay informed about our
              use of cookies and related technologies.
              <br />
              <br />
              The date at the top of this Cookie Policy indicates when it was
              last updated.
            </p>
            <br />
            <br />
            <p>
              We may also use third-party services (such as payment providers or
              authentication services) that set cookies on our website. These
              cookies are used to enable core functionality such as payments and
              secure login.
            </p>
            <p>
              Additionally, some cookies may be set by external domains (such as
              browser providers or services you are logged into) which are
              outside of our control.
            </p>
            <br />
            <h5>Where Can You Get Further Information?</h5>
            <p>
              If you have any questions about our use of cookies or other
              technologies, please email us at{" "}
              <a href="mailto:info@pointmentapp.com">info@pointmentapp.com</a>.
            </p>
          </article>
        </section>
        <TocPrivacyPolicyFooter />
      </div>
    </div>
  );
};

export default CookiesNotice;
